import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const manageEngine = defineConnector({
  identifier: "manageEngine",
  name: "ManageEngine",
  tagLine: "IT management and security solutions",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ serverUrl }) => domainToRegex(serverUrl),
  auth: (app) => headerAuth([{ name: "authtoken", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your ManageEngine API key",
      items: [
        {
          kind: "markdown",
          content: `1. In ManageEngine, go to **Admin › API › API Key Generation**
2. Generate a new API key
3. Copy the key`,
        },
      ],
    },
    {
      title: "Enter your ManageEngine details",
      items: [
        {
          kind: "baseUrl",
          label: "Server URL",
          required: true,
          placeholder: "https://manageengine.example.com",
          target: { kind: "configuration", field: "serverUrl" },
          helperText: "The base URL of your ManageEngine instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) =>
      `${serverUrl}/api/v3/requests?input_data=%7B%22list_info%22%3A%7B%22row_count%22%3A1%7D%7D`,
  },
});
